import { useState } from 'react';
import { Row } from 'reactstrap';
import { useSearchParams } from 'react-router-dom';
import { useUsers } from 'Hooks';
import {
	UserCard,
	ListingPage,
	NoData,
	Pagination,
	UserProfileCardLoading
} from 'Elements';

export const ListUser = () => {
	const [searchParams, setSearchParams] = useSearchParams();
	const params = Object.fromEntries([...searchParams]);
	const pageParam = searchParams.get('page') || 1;
	const queryParam = searchParams.get('q') || '';
	const [state, setState] = useState({
		pageSize: 12,
		currentPage: pageParam,
		keyword: queryParam
	});

	const { data, isFetching } = useUsers({
		pageSize: state.pageSize,
		pageNumber: state.currentPage,
		keyword: state.keyword
	});

	const onChangePageSize = (pageSize: number) => {
		setSearchParams({ ...params, page: '1' });
		setState((prev) => ({
			...prev,
			pageSize,
			currentPage: 1
		}));
	};

	const handleSearch = (query: string) => {
		setSearchParams({
			...params,
			page: '1',
			q: query
		});
		setState((prev) => ({
			...prev,
			currentPage: 1,
			keyword: query
		}));
	};

	const handlePageChange = (page: number) => {
		setSearchParams({ ...params, page: page.toString() });
		setState((prev) => ({
			...prev,
			currentPage: page
		}));
	};

	return (
		<ListingPage
			totalItems={data?.totalItems}
			pageSizes={[4, 8, 12]}
			selectedPageSize={state.pageSize}
			onPageSizeChange={onChangePageSize}
			onSearchChange={handleSearch}>
			<Row className="position-relative">
				{!isFetching &&
					data?.items?.map((user) => {
						return <UserCard key={user.id} user={user} />;
					})}
				{!isFetching && data?.totalItems === 0 && (
					<NoData message="title.no-user" />
				)}
				{isFetching && <UserProfileCardLoading />}
			</Row>
			{!isFetching && data && data?.totalPages > 1 && (
				<Pagination
					totalItemsCount={data?.totalItems}
					activePage={parseInt(state.currentPage.toString(), 10)}
					itemsCountPerPage={state.pageSize}
					onChange={handlePageChange}
				/>
			)}
		</ListingPage>
	);
}

